// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1NEA2","footer":"ModalUpdate_footer__3qD3L"};